/**
 * Organization Templates Deletion API
 * 
 * API enhancement for template deletion that also invalidates organization template cache.
 * Uses the unified /v2/provider/notetemplates/{template_id} endpoint.
 */

import { enhancedApi } from '@store/generated/templates';

const ORG_DELETE_TAG_TYPES = ['OrgTemplateList', 'TemplateList', 'Template'] as const;

export const orgDeleteApi = enhancedApi.enhanceEndpoints({
  addTagTypes: ORG_DELETE_TAG_TYPES,
  endpoints: {
    // Delete template (unified endpoint for all scopes, including org)
    deleteV2ProviderNotetemplatesByTemplateId: {
      invalidatesTags: (_result: any, _error: any, { templateId }: { templateId: string }) => [
        { type: 'OrgTemplateList' as const, id: 'LIST' },
        { type: 'Template' as const, id: templateId },
        { type: 'TemplateList' as const, id: 'LIST' },
      ],
    },
  },
});

export const {
  useDeleteV2ProviderNotetemplatesByTemplateIdMutation: useDeleteOrgTemplateMutation,
} = orgDeleteApi;

